import JustValidate from "just-validate";
import Swal from "sweetalert2";

let requestCallbackForm = document.querySelector("#request-callback");
const requestCallback = new JustValidate(requestCallbackForm);

requestCallback
  .addField(requestCallbackForm.querySelector('[name="first-name"]'), [
    { rule: "required" },
    { 
      rule: "minLength",
      value: 2,
      errorMessage: "Full name is required",
    },
    {
      rule: "customRegexp",
      value: /^([a-zA-z,/.-]+)\s([a-zA-z,/.-]+)$/,
      errorMessage: "Full name is required",
    },
  ])
  .addField(requestCallbackForm.querySelector('[name="email"]'), [
    {
      rule: "required",
    },
    {
      rule: "email",
    },
    {
      validator: (value) => {
        let emailRegex =
          /^[a-zA-Z0-9](?:[a-zA-Z0-9._-]*[a-zA-Z0-9])?@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,7})+$/;
        return emailRegex.test(value);
      },
      errorMessage: "Please Enter Valid Email Address",
    },
  ])
  .addField(requestCallbackForm.querySelector('[name="phone"]'), [
    { rule: "required" },
    { rule: "minLength", value: 9, errorMessage: "Invalid Phone Number" },
    { rule: "maxLength", value: 12, errorMessage: "Invalid Phone Number" },
    {
      rule: "customRegexp",
      value: /^[0-9]+$/,
    },
    {
      rule: "number",
    },
  ])
  .addField(requestCallbackForm.querySelector('[name="Message"]'), [
    { rule: "required" },
  ]);

requestCallback.onSuccess(async (event) => {
  try {
    const formData = new FormData(event.target);

    formData.append("website-link", window.location.href);
    const [nFirstName, lastName] = formData.get("first-name").split(" ");
    formData.set("first-name", nFirstName);
    formData.set("last-name", lastName);

    requestCallbackForm.classList.add("send-data");

    let response = await fetch("/wp-content/themes/s2-labs/student-form.php", {
      body: formData,
      method: "POST",
    });
    if (!response.ok) throw Error("Something Went Wrong");

    let textData = await response.text();
    if (textData.indexOf("Technical Error") > 0) {
      Swal.fire({
        title: "Error!",
        text: "Something went wrong! Please try again after sometime...",
        icon: "error",
        confirmButtonText: "Close",
      });
      window.location.href =
        window.location.href + "?cachebuster=" + new Date().getTime();
      return false;
    }

    fbq("track", "CompleteRegistration");
    Swal.fire({
      title: "Thank you!",
      html: `Our representative will contact you soon.<br>Feel free to reach out to us at <a href="tel:+91 7568697474">+91 7568697474</a> | <a href="tel:+16282010411">+1 628 201 0411</a> | <a target="_blank" href="mailto:gettrained@s2-labs.com">gettrained@s2-labs.com</a>`,
      icon: "success",
      confirmButtonText: "OK",
    });
  } catch {
    Swal.fire({
      title: "Error!",
      text: "Something went wrong! Please try again after sometime...",
      icon: "error",
      confirmButtonText: "OK",
    });
  } finally {
    requestCallbackForm.classList.remove("send-data");
    requestCallbackForm.reset();
  }
});
